'use client'

import { useEffect, useState } from 'react'
import { useAuiState } from '@assistant-ui/react'
import { useShallow } from 'zustand/react/shallow'

const useFileSrc = (file: File | undefined) => {
  const [entry, setEntry] = useState<{ file: File; url: string } | undefined>(undefined)

  useEffect(() => {
    // The object URL is a browser resource whose lifetime has to straddle
    // commit, so allocation, revocation, and clearing the entry that names a
    // revoked URL all belong to the effect.
    if (!file) {
      setEntry(undefined)
      return
    }

    const objectUrl = URL.createObjectURL(file)
    setEntry({ file, url: objectUrl })

    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [file])

  return entry !== undefined && entry.file === file ? entry.url : undefined
}

export const useAttachmentSrc = () => {
  const { file, src } = useAuiState(
    useShallow((s): { file?: File; src?: string } => {
      if (s.attachment.type !== 'image') return {}
      if (s.attachment.file) return { file: s.attachment.file }
      const src = s.attachment.content?.filter((c) => c.type === 'image')[0]?.image
      if (!src) return {}
      return { src }
    })
  )

  return useFileSrc(file) ?? src
}
